export default "__VITE_ASSET__CRJDa_BY__"